import { Modelo } from '@ext/index';
import * as Types from './Ventas.types';
import moment, { Moment } from 'moment';
import { Empresa } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';

export class IVentas extends Modelo {

    public constructor( Json: any = null ) {
        super( Json );
        if ( Json )
            this.set();
    }

    public Mes: number = moment().getMonth();
    public Ano: number = moment().getYear();
    public Empresa: Empresa = null;
    public Ventas: number = 0;

    public get Fecha(): Moment {
        let e = moment();
        e.set( "month", this.Mes - 1 );
        e.set( "year", this.Ano );
        return e;
    }

    public set(): boolean {

        this.Mes = !this.Json.mes ? 0 : this.Json.mes;
        this.Ano = !this.Json.ano ? 0 : this.Json.ano;
        this.Empresa = Empresa.toTipo(this.Json.empresa);
        this.Ventas = !this.Json.ventas ? 0 : this.Json.ventas;

        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista {
        return new Vista( this );
    }
}

class Vista {
    constructor( Model: IVentas ) {
        this.Model = Model;
    }

    public Model: IVentas;
}


